import { Avatar, ListItem, Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { Row } from './Row';
import { ILongtermEquipmentCard } from 'API/LongtermEquipment';
import { BenefitsIcon } from 'Images';

interface IUpdatesList {
  data: ILongtermEquipmentCard[];
}

export const CardsList = ({ data }: IUpdatesList) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack gap={isDesktop ? '48px' : '32px'}>
      <Stack
        gap={isDesktop ? '24px' : '20px'}
        sx={isDesktop ? undefined : { mt: '-80px' }}
      >
        {!isDesktop && (
          <Avatar
            alt=''
            src={BenefitsIcon}
            sx={{
              width: '61px',
              height: '57px',
              position: 'relative',
              top: '32px',
              alignSelf: 'end',
            }}
          />
        )}
        <Stack
          component={'ul'}
          padding={0}
          margin={0}
          gap={isDesktop ? '24px' : '20px'}
        >
          {data.map((row: ILongtermEquipmentCard, index: number) => (
            <ListItem key={index} sx={{ padding: '0' }}>
              <Row data={row} />
            </ListItem>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
